export const formatAddress = (_acc: string) =>
  _acc.slice(0, 5) + '...' + _acc.slice(_acc.length - 4, _acc.length)
